import * as Haptics from 'expo-haptics';
import i18n from '@/utils/i18n';
import React, { useEffect } from 'react';
import { BaseActionSheet } from './base-action-sheet';
import { CloseButton } from './close-button';
import { HappyBox } from './happy-box';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';

export const OrderQueuedComponent = () => {
  return (
    <>
      <HappyBox />
      <Text style={[TYPOGRAPHY.h3, styles.titleText]}>
        {i18n.t('order_queued_action_sheet.title')}
      </Text>
      <Text style={[TYPOGRAPHY.actionSheetMessageText, styles.messageText]}>
        <Text>{i18n.t('order_queued_action_sheet.message')}</Text>
      </Text>
    </>
  );
};

interface Props {
  onClose: () => void;
}

export const OrderQueuedActionSheet: React.FC<Props> = ({ onClose }) => {
  useEffect(() => {
    if (Platform.OS !== 'web') {
      Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
    }
  }, []);

  return (
    <BaseActionSheet contentStyle={styles.content} isVisible onClose={onClose}>
      <View
        style={styles.closeButtonContainer}
        testID="order-queued-action-sheet"
      >
        <CloseButton
          onPress={onClose}
          testID="order-queued-action-sheet-close-button"
          trackingData={{
            name: 'order_queued_action_sheet.close_button',
          }}
        />
      </View>
      <OrderQueuedComponent />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  closeButtonContainer: {
    position: 'absolute',
    right: SCREEN_PADDING,
    top: SCREEN_PADDING,
  },
  content: {
    paddingHorizontal: 48,
    paddingTop: 24,
  },
  messageText: {
    textAlign: 'center',
  },
  titleText: {
    marginBottom: 8,
    textAlign: 'center',
  },
});
